<template>
	<v-dialog
		v-model="showDialog"
		max-width="960px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white"> 在庫引当 </v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
				<div class="mt-2">
					<table width="100%" class="show-dialog-table mt-4">
						<tbody>
							<ShowDetailRecord :columnName="'項目'" :value="'XXX'" />
							<ShowDetailRecord :columnName="'種類'" :value="'XXX'" />
							<ShowDetailRecord :columnName="'寸法・仕様'" :value="'XXX'" />
							<ShowDetailRecord :columnName="'必要数量'" :value="'XXX'" />
						</tbody>
					</table>

					<table class="show-dialog-table mt-4" width="100%">
						<tbody>
							<ShowDetailRecord :columnName="'引当在庫対象'" :value="'XXX'" />
						</tbody>
					</table>
					<v-form ref="form" v-model="valid" class="mt-4">
						<template v-if="type == 'rubber'">
							<table class="show-dialog-table mt-4" width="100%">
								<tbody>
									<ShowDetailRecord :columnName="'材料名'" :value="'XXXXX'" />
									<ShowDetailRecord :columnName="'ロット'" :value="'XXXXX'" />
									<ShowDetailRecord :columnName="'厚み(mm)'" :value="'XXXXX'" />
									<ShowDetailRecord :columnName="'幅(mm)'" :value="'XXXXX'" />
									<ShowDetailRecord :columnName="'長さ(新品)(m)'" :value="'XXXXX'" />
									<ShowDetailRecord :columnName="'総在庫数(m)'" :value="'XXXXX'" />
									<ShowDetailRecord :columnName="'総引当済数(m)'" :value="'XXXXX'" />
									<ShowDetailRecord :columnName="'総引当可能数(m)'" :value="'XXXXX'" />
								</tbody>
							</table>

							<v-row class="mt-4" no-gutters align="end">
								<v-col md="8" cols="12">
									<table class="show-dialog-table" width="100%">
										<tbody>
											<tr>
												<th
													class="font-weight-bold border-right"
													:rowspan="$vuetify.breakpoint.mdAndUp ? 3 : 4"
													width="20%"
												>
													新品本数
												</th>
												<th class="font-weight-bold" width="20%">総本数</th>
												<td width="60%">XXX</td>
											</tr>
											<tr>
												<th class="font-weight-bold" width="20%">引当済</th>
												<td width="60%">XXX</td>
											</tr>
											<tr>
												<th class="font-weight-bold" width="20%">未引当</th>
												<td width="60%">XXX</td>
											</tr>
											<tr v-if="$vuetify.breakpoint.smAndDown">
												<th class="font-weight-bold" width="20%">新規引当</th>
												<td width="60%">
													<v-text-field
														v-model="TODO"
														background-color="white"
														hide-details
														dense
														outlined
													/>
												</td>
											</tr>
										</tbody>
									</table>
								</v-col>
								<v-col v-if="$vuetify.breakpoint.mdAndUp" md="4" class="pl-2">
									<v-text-field label="新規引当" v-model="TODO" dense outlined hide-details />
								</v-col>
							</v-row>
							<!-- 	v-for="(item, i) in item.partially_used_items" -->
							<v-row v-for="i of 2" no-gutters align="end" :key="i">
								<v-col md="8" cols="12">
									<table class="show-dialog-table" width="100%">
										<tbody>
											<tr>
												<th
													class="font-weight-bold border-right"
													:rowspan="$vuetify.breakpoint.mdAndUp ? 4 : 5"
													width="20%"
												>
													使いさし{{ i }}
												</th>
												<th class="font-weight-bold" width="20%">長さ(m)</th>
												<td width="60%">XXX</td>
											</tr>
											<tr>
												<th class="font-weight-bold" width="20%">総本数</th>
												<td width="60%">XXX</td>
											</tr>
											<tr>
												<th class="font-weight-bold" width="20%">引当済</th>
												<td width="60%">XXX</td>
											</tr>
											<tr>
												<th class="font-weight-bold" width="20%">未当済</th>
												<td width="60%">XXX</td>
											</tr>
											<tr v-if="$vuetify.breakpoint.smAndDown">
												<th class="font-weight-bold" width="20%">新規引当</th>
												<td width="60%">
													<v-text-field
														v-model="TODO"
														background-color="white"
														hide-details
														dense
														outlined
													/>
												</td>
											</tr>
										</tbody>
									</table>
								</v-col>
								<v-col v-if="$vuetify.breakpoint.mdAndUp" md="4" class="pl-2">
									<v-text-field label="新規引当" v-model="TODO" dense outlined hide-details />
								</v-col>
							</v-row>
						</template>

						<template v-if="type == 'item_kg'">
							<table class="show-dialog-table mt-4" width="100%">
								<tbody>
									<ShowDetailRecord :columnName="'材料名'" :value="'XXXXX'" />
									<ShowDetailRecord :columnName="'ロット'" :value="'XXXXX'" />
									<ShowDetailRecord :columnName="'入り目(kg)'" :value="'XXXXX'" />
									<ShowDetailRecord :columnName="'総在庫数(kg)'" :value="'XXXXX'" />
									<ShowDetailRecord :columnName="'総引当済数(kg)'" :value="'XXXXX'" />
									<ShowDetailRecord :columnName="'総引当可能数(kg)'" :value="'XXXXX'" />
								</tbody>
							</table>

							<v-row no-gutters align="end">
								<v-col md="8" cols="12">
									<table class="show-dialog-table" width="100%">
										<tbody>
											<tr>
												<th
													class="font-weight-bold border-right"
													:rowspan="$vuetify.breakpoint.mdAndUp ? 3 : 4"
													width="20%"
												>
													新品缶数
												</th>
												<th class="font-weight-bold" width="20%">総缶数</th>
												<td width="60%">XXX</td>
											</tr>
											<tr>
												<th class="font-weight-bold" width="20%">引当済</th>
												<td width="60%">XXX</td>
											</tr>
											<tr>
												<th class="font-weight-bold" width="20%">未引当</th>
												<td width="60%">XXX</td>
											</tr>
											<tr v-if="$vuetify.breakpoint.smAndDown">
												<th class="font-weight-bold" width="20%">新規引当</th>
												<td width="60%">
													<v-text-field
														v-model="TODO"
														background-color="white"
														hide-details
														dense
														outlined
													/>
												</td>
											</tr>
										</tbody>
									</table>
								</v-col>
								<v-col v-if="$vuetify.breakpoint.mdAndUp" md="4" class="pl-2">
									<v-text-field label="新規引当" v-model="TODO" dense outlined hide-details />
								</v-col>
							</v-row>
							<!-- 	v-for="(item, i) in item.partially_used_items" -->
							<v-row v-for="i of 2" no-gutters align="end" :key="i">
								<v-col md="8" cols="12">
									<table class="show-dialog-table" width="100%">
										<tbody>
											<tr>
												<th
													class="font-weight-bold border-right"
													:rowspan="$vuetify.breakpoint.mdAndUp ? 2 : 3"
													width="20%"
												>
													使いさし{{ i }}
												</th>
												<th class="font-weight-bold" width="20%">重量</th>
												<td width="60%">XXX</td>
											</tr>
											<tr>
												<th class="font-weight-bold" width="20%">状態</th>
												<td width="60%">XXX</td>
											</tr>
											<tr v-if="$vuetify.breakpoint.smAndDown">
												<th class="font-weight-bold" width="20%">新規引当</th>
												<td width="60%">
													<v-text-field
														v-model="TODO"
														background-color="white"
														hide-details
														dense
														outlined
													/>
												</td>
											</tr>
										</tbody>
									</table>
								</v-col>
								<v-col v-if="$vuetify.breakpoint.mdAndUp" md="4" class="pl-2">
									<v-text-field label="新規引当" v-model="TODO" dense outlined hide-details />
								</v-col>
							</v-row>
						</template>
						<template v-if="type == 'item_quantity'">
							<table class="show-dialog-table mt-4" width="100%">
								<tbody>
									<ShowDetailRecord :columnName="'材料名'" :value="'XXXXX'" />
									<ShowDetailRecord :columnName="'ロット'" :value="'XXXXX'" />
								</tbody>
							</table>

							<table class="show-dialog-table mt-4" width="100%">
								<tbody>
									<ShowDetailRecord :columnName="'在庫数'" :value="'XX'" />
									<ShowDetailRecord :columnName="'引当済数'" :value="'XX'" />
									<ShowDetailRecord :columnName="'引当可能数'" :value="'XX'" />
								</tbody>
							</table>
							<v-sheet elevation="0" max-width="300">
								<v-text-field
									label="新規引当"
									class="mt-4"
									v-model="TODO"
									dense
									outlined
									hide-details
								/>
							</v-sheet>
						</template>
					</v-form>
				</div>
			</div>

			<v-card-actions>
				<v-row no-gutters>
					<v-col sm="2" cols="0" />
					<v-col sm="8" cols="12" class="text-center">
						<v-btn color="secondary" @click="submitForm" :disabled="!valid">
							<v-icon class="mr-1">mdi-plus</v-icon>
							引当データ作成
						</v-btn>
					</v-col>
					<v-col sm="2" cols="0" class="text-right">
						<v-btn v-if="!$vuetify.breakpoint.xs" color="grey darken-1" text @click="closeDialog">
							キャンセル
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		type: {
			type: String,
			required: true,
		},
		item: {
			type: Object,
			required: true,
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			TODO: null,
			valid: false,
			rules,
		}
	},
	methods: {
		submitForm() {
			// TODO: 引当処理
			const headers = authenticate.setHeader()
			const url = ``
			const params = {}
			axios
				.post(url, params, {
					headers,
				})
				.then((res) => {})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		closeDialog() {
			this.$refs.form.reset()
			this.showDialog = false
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(val) {
				this.$emit("update:dialog", val)
			},
		},
	},
}
</script>

<style lang="scss" scoped>
.border-right {
	border-right: 1px solid white;
}
</style>